import { type PropsWithChildren } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { captureTokenFromUrl } from '@/lib/token';
import { store, persistor } from './index';
import { setToken } from './slices/authSlice';

// Captured at module load time so the URL param is stripped immediately and
// the value is ready to dispatch in onBeforeLift after rehydration completes.
const urlToken = captureTokenFromUrl();

export function ReduxProvider({ children }: PropsWithChildren) {
  return (
    <Provider store={store}>
      <PersistGate
        loading={null}
        persistor={persistor}
        onBeforeLift={() => { if (urlToken) store.dispatch(setToken(urlToken)); }}
      >
        {children}
      </PersistGate>
    </Provider>
  );
}
